// extracted by css-extract-rspack-plugin
export default {"distinction":"_390fc4d7","title":"_6f462d25","description":"_f5831a43"};